import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Plus } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { memo } from "react";
import { ADD_CUSTOM_FIELD_MINI_BUTTON, CUSTOM_FIELD_LIST, CUSTOM_FIELD_PANEL } from "~/constants/testIDs";
export const CustomFieldsPanel = /*#__PURE__*/ memo((param)=>{
    let { onCreateClick, fields } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": CUSTOM_FIELD_PANEL,
        className: "relative flex size-full flex-col items-start justify-start",
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": CUSTOM_FIELD_LIST,
                className: "flex w-full flex-1 flex-col items-start justify-start overflow-auto p-4",
                children: fields
            }),
            !!onCreateClick && /*#__PURE__*/ _jsx("div", {
                className: "flex h-16 w-full shrink-0 items-center justify-start border-t border-t-grey-4 bg-grey-1 pl-4",
                children: /*#__PURE__*/ _jsx(Button, {
                    appearance: "ghost",
                    color: "grey",
                    className: "w-full justify-start",
                    "data-testid": ADD_CUSTOM_FIELD_MINI_BUTTON,
                    onClick: onCreateClick,
                    prefix: /*#__PURE__*/ _jsx(Plus, {
                        className: "size-4"
                    }),
                    size: "large",
                    children: "Add custom field"
                })
            })
        ]
    });
});
CustomFieldsPanel.displayName = "CustomFieldsPanel";
